import React from 'react';
import packageJson from '../package.json';

global.appVersion = packageJson.version;

// versionA = package
// versionB = meta
const checkVersion = (versionA, versionB) => {
    const splitA = versionA.split(/\./g);
    const splitB = versionB.split(/\./g);

    while (splitA.length ||
        splitB.length) {
        const a = Number(splitA.shift());
        const b = Number(splitB.shift());

        if (a === b) {
            continue;
        }

        return (
            a > b ||
            isNaN(b)
        );
    }

    return false;
};

export default class CacheBuster extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emptyCacheAndReload: () => {
                console.log("Performing empty cache and hard reload...");
                if (caches) {
                    // Service worker cache should be cleared with caches.delete()
                    caches.keys()
                        .then(async function (names) {
                            await Promise.all(names.map(name => caches.delete(name)));
                            // Perform a hard reload
                            window.location.reload(true);
                        });
                }
                else {
                    // Perform a hard reload
                    window.location.reload(true);
                }
            },
            isCurrentVersion: false,
            loading: true
        };
    }

    componentDidMount() {
        fetch(`/meta.json?${new Date().getTime()}`, { cache: 'no-cache' })
            .then((response) => response.json())
            .then((meta) => {
                const packageVersion = global.appVersion;
                const forceRefresh = checkVersion(packageVersion, meta.version);

                if (forceRefresh) {
                    console.log(`New HCS Portal version (${packageVersion}) - forcing refresh in 3 seconds.`);
                    this.setState({
                        isCurrentVersion: false,
                        loading: false
                    });
                }
                else {
                    console.log(`Current HCS Portal version cached (${packageVersion}) - no refresh necessary.`);
                    this.setState({
                        isCurrentVersion: true,
                        loading: false
                    });
                }
            });
    }

    render() {
        const {
            emptyCacheAndReload,
            isCurrentVersion,
            loading
        } = this.state;

        return this.props.children({
            emptyCacheAndReload,
            isCurrentVersion,
            loading
        });
    }
}



// WEBPACK FOOTER //
// ./src/CacheBuster.js